module.exports = __webpack_public_path__ + "img/SIS.a7b8124b.jpg";